<template>
    <div class="image-list-itme">
        <div class="img-box">
            <img :src="require(`@/assets/${src}`)" alt="" />
        </div>
        <div class="text-box">
            <p class="title">{{ title }}</p>
            <p class="desc" v-html="desc"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
        desc: {},
        src: {},
    },
};
</script>
<style lang="scss" scoped>
.image-list-itme {
    display: flex;
    flex-direction: column;
    flex: 1 0 492px;

    .img-box {
        width: 100%;
        height: 300px;
        margin-bottom: 40px;

        @media screen and (max-width: 768px) {
            height: 250px;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .text-box {
        width: 100%;

        .title {
            font-family: 'Pretendard', sans-serif;
            margin-bottom: 30px;
            font-size: 22px;
            font-weight: 700;
            color: var(--black1);
            letter-spacing: -0.025em;
            word-break: keep-all;
            @media screen and (max-width: 768px) {
                font-size: 20px;
            }
        }

        .desc {
            font-family: 'Pretendard', sans-serif;
            font-size: 18px;
            letter-spacing: -0.025em;
            line-height: 1.6;
            font-weight: 400;
            color: var(--black3);
            word-break: keep-all;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }
    }
}
</style>
